import { useContext } from 'react';
import { LayoutTargetContext } from '../context/layout-target-context';
export var useLayoutTarget = function () {
  return useContext(LayoutTargetContext) || 'aside';
};
export var useIsMain = function () {
  return useLayoutTarget() === 'main';
};
export var useIsAside = function () {
  return useLayoutTarget() === 'aside';
};